<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  rank: number
  color: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="cn('pointer-events-none absolute right-[15.5px] top-[-4.5px] h-[42px] w-8', props.class)"
    :aria-label="`Rank ${rank}`"
  >
    <svg
      aria-hidden="true"
      class="absolute inset-0 size-full"
      viewBox="0 0 32 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V42L16 32L0 42V4Z" :fill="color" />
    </svg>
    <span aria-hidden="true" class="absolute left-[13px] top-[11px] text-sm font-normal leading-none text-white">
      {{ rank }}
    </span>
  </div>
</template>
